/** The tour record's phone preview (plan §4, D6): the records' page-level preview
 *  (`RecordPreviewProvider` — one render state for the page, on demand only, following the
 *  Itinerary tab's selected day) with the tour's draft: `compileTourPatch(...).body`, the
 *  same body Save would send, pins included. Viewers without `console_tours_manage` get the
 *  saved tour (a draft render needs manage). */
import { useCallback, type ReactNode } from 'react';

import { compileChanges, type DraftState } from '@/features/records/draft/changeSet';
import { RecordPreviewProvider } from '@/features/records/preview/RecordPreviewProvider';

import { compileTourPatch } from '../record/compile';
import { useTourRecord } from '../record/TourRecordContext';

export function TourPreviewProvider({ canDraft, children }: { canDraft: boolean; children: ReactNode }) {
  const { detail, baseline, files } = useTourRecord();
  const request = useCallback(
    (state: DraftState) => ({ draft: compileTourPatch(compileChanges(state), baseline, files).body as Record<string, unknown> }),
    [baseline, files],
  );
  return (
    <RecordPreviewProvider entity="tour" id={detail.id} canDraft={canDraft} updatedTs={detail.updated_ts ?? null} request={request}>
      {children}
    </RecordPreviewProvider>
  );
}
